import React from "react";

import ArrowDropDown from "@mui/icons-material/ArrowDropDown";
import { Button } from "@mui/material";

import { useReportsQueriesSelector } from "../../../store";
import { GroupByCurrency } from "../Group-by-currency/GroupByCurrency";
import { GroupByMenu } from "../Group-by-menu/GroupByMenu";

export const SelectCurrency = () => {
  const { currency } = useReportsQueriesSelector();

  return (
    <GroupByMenu
      renderTrigger={(params) => (
        <Button
          {...params}
          sx={{
            bgcolor: "#ffffff",
            padding: "0 15px 0 15px",
            border: "solid 1px #dae0e2",
            minWidth: 0,
            fontSize: "15px",
            color: "#5d7782",
            minHeight: 0
          }}
          endIcon={<ArrowDropDown />}
        >
          {currency}
        </Button>
      )}
    >
      <GroupByCurrency />
    </GroupByMenu>
  );
};
